import { State } from 'src/redux/reducer';
import { isLoaded, isPending, shouldLoad } from 'src/redux/utils';

export const currentUsersSelector = (state: State) =>
  state.currentUsers.entities;
export const currentUsersStatusSelector = (state: State) =>
  state.currentUsers.status;
export const currentUsersLoadedSelector = isLoaded(currentUsersStatusSelector);
export const currentUsersPendingSelector = isPending(
  currentUsersStatusSelector,
);
export const shouldCurrentUsersSelector = shouldLoad(
  currentUsersStatusSelector,
);
